<template>
  <Panel header="Danh sách văn bản">
    <div class="w-full">
      <DataTable
        :value="listDocumentProcess"
        :paginator="true"
        stripedRows
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        :rowHover="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        v-model:filters="filters"
        :globalFilterFields="['title', 'sender']"
        currentPageReportTemplate="Có tổng số {totalRecords} văn bản"
        resizableColumns
        tableclass="h-[60px]"
      >
        <template #header>
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex w-full flex-col gap-3">
              <div class="flex gap-3">
                <Button
                  type="button"
                  icon="pi pi-filter-slash"
                  label="Xoá lọc"
                  outlined
                  @click="clearFilter()"
                />
                <span class="relative flex flex-1">
                  <i
                    class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400"
                  />
                  <InputText
                    class="!w-[500px] !pl-10 !pr-3"
                    v-model="filters['global'].value"
                    placeholder="Tìm theo tên hoặc số điện thoại"
                  />
                </span>
              </div>
              <!--              <Button-->
              <!--                  type="button"-->
              <!--                  icon="pi pi-trash"-->
              <!--                  label="Xoá đã chọn"-->
              <!--                  severity="danger"-->
              <!--                  @click="deleteSelectedPeople()"-->
              <!--                  :loading="deletingSelected"-->
              <!--                  :disabled="selectedPeopleIds.length < 1"-->
              <!--                  class="w-fit"-->
              <!--              />-->
            </div>
          </div>
        </template>

        <Column
          field="title"
          header="Tiêu đề văn bản"
          sortable
          class="h-[60px]"
        ></Column>
        <Column
          field="sender"
          header="Người gởi"
          class="h-[60px]"
          sortable
        ></Column>
        <Column field="time" header="Thời gian" class="h-[60px]" sortable>
          <template #body="slotProps">
            {{ formatDateTime(slotProps.data.time) }}
          </template>
        </Column>
        <Column field="status" header="Trạng thái" class="h-[60px]" sortable>
          <template #body="slotProps">
            <Button
              outlined
              label="Đã xử lý"
              icon="pi pi-check"
              v-if="slotProps.data.status"
              @click="goToViewDocument(slotProps.data.id)"
            />
            <Button
              outlined
              severity="danger"
              label="Chưa xử lý"
              icon="pi pi-hourglass"
              v-else
              @click="goToViewDocument(slotProps.data.id)"
            />
            <!-- Chổ ni bấm là gọi qua api viewdocument/{id} -->
          </template>
        </Column>
      </DataTable>
    </div>

    <!-- Confirm Delete Modal -->
  </Panel>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useToast } from "@/ui/services/toast";
import AuthRepository from "@/services/AuthRepository";
import { useStore } from "vuex";
import router from "@/router";
import { FilterMatchMode } from "@/ui/services/api";
import { Team } from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import moment from "moment";
import authRepository from "@/services/AuthRepository";
import { UserDetail } from "@/models/userDetail";
import { CustomerUpdate } from "@/models/customerUpdate";
import zaloRepository from "@/services/ZaloRepository";
import { ListGroup } from "@/models/listGroup";
import { RegisterCivilGroup } from "@/models/registerCivilGroup";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";
import { DocumentProcess } from "@/models/documentProcess";

export default {
  components: {
    ConfirmDeleteModal,
  },
  setup() {
    const toast = useToast();
    const listDocumentProcess = ref([] as DocumentProcess[]);
    const loadingBar = ref(false);
    // if(store.state.permission == "admin")
    //
    const loadListDocument = () => {
      loadingBar.value = true;
      zaloRepository
        .getListDocumentProcess()
        .then((response) => {
          listDocumentProcess.value = response.data;
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách văn bản",
            life: 2000,
          });
        })
        .finally(() => {});
    };

    loadListDocument();

    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };
    const formatDateTime = (date) => {
      return moment(String(date)).format("DD/MM/YYYY");
    };
    const goToViewDocument = (id: number) => {
      router.push({
        name: "viewDocument",
        params: { id },
      });
    };

    return {
      listDocumentProcess,
      filters,
      clearFilter,
      initFilters,
      formatDateTime,
      goToViewDocument,
    };
  },
};
</script>
`r`n
